import { getProjects } from '../../data/dataLoader'

const projectsData = getProjects()

const personalProjects = projectsData.personal_projects.map(project => ({
  ...project,
  github: project.github || '#',
  live: project.live || '#'
}))

export const orgProjects = projectsData.org_projects
  ? projectsData.org_projects.map(project => ({ ...project }))
  : []

export const companyProjects = projectsData.company_projects
  ? projectsData.company_projects.map(project => ({
      ...project,
      github: project.github || '#',
      live: project.live || '#'
    }))
  : []

export default personalProjects